<div id="container-resident-engagement">
  <ngb-carousel
    [showNavigationArrows]="false"
    [showNavigationIndicators]="false">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img
          src="assets/images/resident-engagement/resident-engagement-header.png"
          alt="TSOLife" />
      </div>
      <div class="carousel-caption text-start">
        <h1>Build a vibrant, engaging senior <br />living community</h1>
        <h2>
          Easily plan activities catered to your residents’ interests — then
          instantly promote them through digital signage, professional-quality
          newsletters, and family communications. You can make informed planning
          decisions to improve resident satisfaction and long-term retention
          with a single platform to manage your calendar, communications,
          tracking, and analytics.
        </h2>
        <a
          class="btn btn-danger btn-lg m-btn-schedule cursor-pointer engagement-contact-btn"
          (click)="triggerScrollTo('front-end-form')"
          >Contact Us To Learn More</a
        >
      </div>
    </ng-template>
  </ngb-carousel>

  <div class="row justify-content-center p-2 mt-5 features-header">
    <div class="col-lg-10">
      <div class="text-center">
        <h2>A SINGLE, FULLY INTEGRATED PLATFORM FOR RESIDENT ENGAGEMENT</h2>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-4 mb-5">
    <div class="col-lg-11">
      <div class="row justify-content-center features-container">
        <div class="col-md-6 col-lg-4 col-xl-3 feature-card p-sm-4 p-lg-3">
          <div class="card card-home-page h-100" id="dark-blue-item">
            <div class="card-body d-flex align-items-center">
              <div class="text-white">
                <h2 class="card-title mb-4">Activities Calendar</h2>
                <p class="card-text">
                  Fueled by data, energize your community with an
                  easy-to-manage, dynamic calendar of events.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 col-xl-3 feature-card p-sm-4 p-lg-3">
          <div class="card card-home-page h-100" id="green-item">
            <div class="card-body d-flex align-items-center">
              <div class="text-white">
                <h2 class="card-title mb-4">Print and Digital Newsletters</h2>
                <p class="card-text">
                  Keep residents and families informed with customizable
                  newsletters.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 col-xl-3 feature-card p-sm-4 p-lg-3">
          <div class="card card-home-page h-100" id="red-item">
            <div class="card-body d-flex align-items-center">
              <div class="text-white">
                <h2 class="card-title mb-4">Digital Signage</h2>
                <p class="card-text">
                  Display activities, announcements, photos, and more — with
                  real-time updates when changes are made to the calendar.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 col-xl-3 feature-card p-sm-4 p-lg-3">
          <div class="card card-home-page h-100" id="yellow-item">
            <div class="card-body d-flex align-items-center">
              <div class="text-white">
                <h2 class="card-title mb-4">Family Communications</h2>
                <p class="card-text">
                  Help loved ones stay in the loop with photo sharing, activity
                  updates, and direct messaging with the staff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-home-page-white p-5">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="mtb-50 text-start center-text">
          <h2 class="card-title my-4">
            Easily plan, promote, and manage your activities calendar
          </h2>
          <p class="card-text my-4">
            Tailor your community’s events to your residents’ interests. TSOLife
            makes it easy to customize event categories, track RSVPs, and share
            the calendar with residents and staff. A more informed senior living
            community leads to a happier, more active community.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/banners/new-calendar.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="card card-home-page p-5">
    <div class="row align-items-center">
      <div class="col-md-5 offset-md-1">
        <img
          class="card-img img-fluid img-80"
          src="assets/images/banners/newsletter.png"
          alt="TSOLife Calendar" />
      </div>

      <div class="col-md-5">
        <div class="mtb-50 text-start center-text">
          <h2 class="card-title my-4">
            Get professional-looking newsletters, delivered digitally or printed
            in minutes
          </h2>
          <p class="card-text my-4">
            We make it easy to create and print custom newsletters, flyers, and
            other materials — integrated with your activities calendar. With a
            range of templates and customization options, your digital and print
            communications will match your community’s branding and style. With
            the ability to print directly from the TSOLife platform, you'll save
            time and money.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-home-page-white p-5">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="mtb-50 text-start center-text">
          <h2 class="card-title my-4">
            Keep your community informed about activities and news with digital
            signage
          </h2>
          <p class="card-text my-4">
            Our digital signage automatically syncs when the calendar changes —
            so you can instantly share real time updates, personalized messages,
            photos and your dynamic schedule of activities. The signage is
            customizable and easily tailored to fit your community’s unique
            needs.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/resident-engagement/mac-device.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="card card-home-page-white bg-transparent p-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <img
          class="card-img img-fluid w-100"
          src="assets/images/resident-engagement/iphone-mockup.png"
          alt="Leveraging voice-to-text to automate data collection" />
      </div>
      <div class="col-md-5">
        <div class="mtb-50 text-start center-text">
          <h2 class="card-title my-4">
            Improve resident satisfaction and retention with our family
            communication app
          </h2>
          <p class="card-text my-4">
            TSOLife's family app keeps residents’ loved ones connected with
            direct messaging to staff, access to the community calendar,
            resident attendance, events, and photo galleries. With a more
            cohesive experience for families, loved ones can be more involved,
            and residents can feel more connected, enhancing their quality of
            life in your community.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-home-page-white text-center" id="front-end-form">
    <div class="container">
      <div class="row mtb-50 align-items-center">
        <div class="col-md-4 main-img">
          <img
            class="card-img-top img-fluid"
            src="assets/images/homepage/dashboard-mockup.png" />
        </div>
        <div class="col-md-7">
          <div>
            <h2 class="card-title engaged-section-title mt-0 text-center">
              READY TO BUILD A MORE ENGAGED, VIBRANT SENIOR LIVING COMMUNITY?
            </h2>
          </div>
          <a
            class="btn btn-lg btn-primary"
            href="https://get.tsolife.com/contact-us"
            >Schedule Demo</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
